var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartdiv",staticClass:"chart--semi-circle"})
}
var staticRenderFns = []

export { render, staticRenderFns }